(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/api-calls/update-draws.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/api-calls/update-draws.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const asyncDrawApi = svs.numbergames.draws.asyncDrawsApi;
async function updateDraws(_ref) {
  let next = _ref.next,
    wagers = _ref.wagers;
  const products = wagers.flatMap(_ref2 => {
    let bets = _ref2.bets;
    return bets.map(bet => bet.productId);
  }).filter(productId => !productMapping.isJoker(productId));
  const draws = await asyncDrawApi.firstPlayableDraw(products);
  next({
    draws
  });
}
svs.numbergames.pay_numbergames.updateDraws = updateDraws;

 })(window);